import styled from "styled-components";

import { Typography } from "styled/Typography";
import { theme } from "theme";

export const SummaryTitle = styled(Typography.Title)`
  color: ${theme.color.text.tertiary};
`;
